<template>
	<b-form autocomplete="off">
		<h3>Nome</h3>
		<b-form-row>
			<b-col cols="12">
				<input-component
					v-model="company"
					:required="true"
					label="Razão Social"
					maxlength="255"
					name="company" />
			</b-col>

			<b-col cols="12">
				<input-component
					v-model="company_fantasy"
					:required="true"
					label="Nome Comercial/Fantasia"
					maxlength="255"
					name="company_fantasy" />
			</b-col>
		</b-form-row>

		<h3>Endereço registrado</h3>
		<address-form-component ref="mainAddress" />

		<h3>Endereço físico da sede administrativa</h3>
		<b-form-group
			:label-cols="$root.isMobile() ? '12' : '6'"
			class="mb-4"
			label="Seu endereço físico é o mesmo endereço do registrado?">
			<b-form-radio-group
				id="same_address"
				v-model="same_address"
				:options="addressOptions"
				name="same_address" />
		</b-form-group>

		<address-form-component v-if="!same_address" ref="secondAddress" class="mt-5" />

		<h3>Grupo econômico</h3>
		<b-form-group
			:label-cols="$root.isMobile() ? '12' : '6'"
			class="mb-4"
			label="A empresa faz parte de algum grupo econômico?">
			<b-form-radio-group id="group" v-model="has_group" :options="groupOptions" name="group" />
		</b-form-group>

		<div v-if="has_group">
			<b-form-row class="mt-5">
				<b-col cols="12" md="8">
					<input-component
						v-model="group_name"
						:required="has_group"
						label="Nome do grupo"
						maxlength="255"
						name="group_name" />
				</b-col>

				<b-col cols="12" md="4">
					<input-component
						v-model="group_cnpj"
						:check="true"
						:mask="'##.###.###/####-##'"
						:required="has_group"
						label="CNPJ"
						maxlength="50"
						name="group_cnpj" />
				</b-col>
			</b-form-row>
		</div>

		<h3>Outros dados</h3>
		<b-form-row>
			<b-col cols="12" md="7">
				<input-component v-model="website" :required="true" label="Website" maxlength="255" name="website" />
			</b-col>

			<b-col cols="12" md="5">
				<input-component
					v-model="product"
					:required="true"
					label="Website do produto / serviço"
					maxlength="255"
					name="product" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="6" md="3">
				<input-component
					v-model="age"
					:check="true"
					:mask="'##/##/####'"
					:required="true"
					label="Data de fundação"
					maxlength="50"
					name="age" />
			</b-col>

			<b-col cols="6" md="4">
				<input-component
					v-model="cnpj"
					:check="true"
					:mask="'##.###.###/####-##'"
					:required="true"
					disabled
					label="CNPJ"
					maxlength="50"
					name="cnpj" />
			</b-col>

			<b-col cols="12" md="5">
				<input-component
					v-model="type"
					:required="true"
					label="Tipo (EIRELI, EPP, LTDA, S.A, etc.)"
					maxlength="50"
					name="type" />
			</b-col>
		</b-form-row>

		<h3>Produto / Serviço</h3>
		<b-form-row>
			<b-col cols="12" md="12">
				<select-component
					v-model="product_category"
					:options="categories"
					:required="true"
					label="Selecione a categoria do produto / serviço"
					name="product_category" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" md="12">
				<textarea v-model="product_description" placeholder="Descreva aqui o seu produto / serviço." rows="2">
				</textarea>
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col class="mmb-4" cols="12" md="6">
				<span auto-resize class="legend" rows="1">Qual o tempo médio para a entrega do produto?</span>
			</b-col>

			<b-col cols="12" md="6">
				<select-component
					v-model="product_shipping"
					:options="shippingOptions"
					:required="true"
					label="Selecione o número de dias"
					name="product_shipping" />
			</b-col>
		</b-form-row>

		<b-form-checkbox id="checkbox-confirm" v-model="agreeCheckbox" class="mb-3" name="checkbox-confirm">
			Declaro que sou o(a) responsável legal pela empresa, e me responsabilizo pelas informações prestadas.
		</b-form-checkbox>
	</b-form>
</template>

<script>
	import { required, requiredIf } from "vuelidate/lib/validators";

	import categories from "@/static/categories";

	import InputComponent from "@/components/Form/Inputs/InputComponent";
	import SelectComponent from "@/components/Form/Inputs/SelectComponent";
	import AddressFormComponent from "@/components/Form/AddressFormComponent";

	export default {
		name: "EstablishmentFormComponent",
		components: {
			InputComponent,
			SelectComponent,
			AddressFormComponent,
		},
		props: ["validationTrigger"],
		mounted() {
			if (this.$store.state.form.establishment.company) {
				this.$emit("setReadyToSubmit", false);
				this.$store.state.form.establishment.agree = false;

				this.$v.$touch();
				this.$refs.mainAddress.$v.$touch();

				if (this.$store.state.form.establishment.address[1].cep) {
					this.$refs.secondAddress.$v.$touch();
				}
			}

			this.$store.dispatch("updateStep", this.step);
		},
		data() {
			return {
				shippingOptions: [
					"Imediatamente",
					"Até 7 dias úteis",
					"Até 15 dias úteis",
					"Até 30 dias úteis",
					"Até 60 dias úteis",
					"Maior ou igual a 60 dias úteis",
				],
				addressOptions: [
					{
						text: "Sim, é o mesmo endereço.",
						value: true,
					},
					{
						text: "Não, é outro.",
						value: false,
					},
				],
				groupOptions: [
					{
						text: this.$t("messages.yes"),
						value: true,
					},
					{
						text: this.$t("messages.no"),
						value: false,
					},
				],
			};
		},
		watch: {
			isValid(value) {
				this.$emit("setReadyToSubmit", value);
			},
			validationTrigger() {
				this.$emit("setReadyToSubmit", this.isValid);
			},
		},
		computed: {
			isValid() {
				return (
					this.agreeCheckbox &&
					!this.$v.$invalid &&
					this.$refs.mainAddress &&
					!this.$refs.mainAddress.$v.$invalid &&
					(this.same_address || (this.$refs.secondAddress && !this.$refs.secondAddress.$v.$invalid))
				);
			},
			agreeCheckbox: {
				get() {
					return this.$store.state.form.establishment.agree;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "agree",
						value,
					});
				},
			},
			company: {
				get() {
					return this.$store.state.form.establishment.company;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "company",
						value,
					});
				},
			},
			company_fantasy: {
				get() {
					return this.$store.state.form.establishment.company_fantasy;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "company_fantasy",
						value,
					});
				},
			},
			website: {
				get() {
					return this.$store.state.form.establishment.website;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "website",
						value,
					});
				},
			},
			product: {
				get() {
					return this.$store.state.form.establishment.product;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "product",
						value,
					});
				},
			},
			age: {
				get() {
					return this.$store.state.form.establishment.age;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "age",
						value,
					});
				},
			},
			cnpj: {
				get() {
					return this.$store.state.form.establishment.cnpj;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "cnpj",
						value,
					});
				},
			},
			type: {
				get() {
					return this.$store.state.form.establishment.type;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "type",
						value,
					});
				},
			},
			same_address: {
				get() {
					return this.$store.state.form.establishment.sameAddress;
				},
				set(value) {
					this.agreeCheckbox = false;
					this.$store.commit("setEstablishment", {
						key: "sameAddress",
						value,
					});
				},
			},
			has_group: {
				get() {
					return this.$store.state.form.establishment.hasGroup;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "hasGroup",
						value,
					});
				},
			},
			product_category: {
				get() {
					return this.$store.state.form.establishment.product_category;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "product_category",
						value,
					});
				},
			},
			product_description: {
				get() {
					return this.$store.state.form.establishment.product_description;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "product_description",
						value,
					});
				},
			},
			product_shipping: {
				get() {
					return this.$store.state.form.establishment.product_shipping;
				},
				set(value) {
					this.$store.commit("setEstablishment", {
						key: "product_shipping",
						value,
					});
				},
			},
			group_name: {
				get() {
					return this.$store.state.form.establishment.group.name;
				},
				set(value) {
					this.$store.commit("setEstablishmentGroup", {
						key: "name",
						value,
					});
				},
			},
			group_cnpj: {
				get() {
					return this.$store.state.form.establishment.group.cnpj;
				},
				set(value) {
					this.$store.commit("setEstablishmentGroup", {
						key: "cnpj",
						value,
					});
				},
			},
			categories() {
				return categories;
			},
			step() {
				return this.$store.state.form.step;
			},
		},
		validations: {
			company: {
				required,
			},
			company_fantasy: {
				required,
			},
			website: {
				required,
			},
			product: {
				required,
			},
			age: {
				required,
				isValidDate(date) {
					return this.$root.isValidDate(date);
				},
			},
			cnpj: {
				required,
				isValidCNPJ(cnpj) {
					return this.$root.isValidCNPJ(cnpj);
				},
			},
			type: {
				required,
			},
			group_name: {
				requiredIf: requiredIf(function () {
					return this.has_group;
				}),
			},
			group_cnpj: {
				requiredIf: requiredIf(function () {
					return this.has_group;
				}),
				isValidCNPJ(cnpj) {
					return this.$root.isValidCNPJ(cnpj) || !this.has_group;
				},
			},
			product_category: {
				required,
			},
			product_shipping: {
				required,
			},
		},
	};
</script>
